import { Plus } from '@/shared/assets';
import { Button, Header, Typography } from '@/shared/ui';

import { regularStatements, statements } from '../../mock/statements';
import { RegularStatementItem } from './regular-statement-item';
import { StatementItem } from './statement-item';

export const StatementWidget = () => {
  return (
    <div className="flex h-full w-full flex-col pt-6">
      <Header
        className="px-5 pb-6 md:px-6"
        title="Statements"
        action={{ as: 'button', label: 'See history', onClick: () => void 0 }}
      />

      <div className="mb-4 flex flex-col gap-y-3 px-5 md:px-6">
        {statements.slice(0, 2).map((statement, idx) => (
          <StatementItem statement={statement} key={idx} />
        ))}
      </div>

      <div className="mx-1 mt-1 flex flex-col gap-y-5 rounded-[28px] bg-base-300 p-5 pb-[10px]">
        <div className="flex w-full items-center justify-between">
          <Typography variant="14-r" color="text-base-100">
            Regular statements
          </Typography>

          <Button className="gap-1 p-0 text-sm" variant="blue-link">
            Add
            <Plus />
          </Button>
        </div>

        <RegularStatementItem statement={regularStatements[0]} />
      </div>
    </div>
  );
};
